import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ErrorOverlay } from '@ff-os/shared-react/components/error-overlay/ErrorOverlay';
import { FlyIn } from '@ff-os/shared-react/components/fly-in/FlyIn';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import styles from './PhotoPrintMobileErrorOverlay.module.scss';

const _PhotoPrintMobileErrorOverlay = ({ removePhoto }: Props) => {

    const [isOverlayOpen, setOverlayOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <ErrorOverlay onClick={() => setOverlayOpen(true)}>
            <div className={styles.iconContainer}>
                <Icon type='general-ui-bin' className={styles.binIcon} strokeWidth={2} />
            </div>

            {isOverlayOpen && (
                <WindowStackItem>
                    <FlyIn from='bottom' hide={() => setOverlayOpen(false)}>
                        <FlyIn.MenuItem
                            icon={<Icon className={styles.deleteIcon} type='general-ui-bin' />}
                            className={styles.deleteButton}
                            onClick={removePhoto}>
                            {t('commons.delete')}
                        </FlyIn.MenuItem>
                    </FlyIn>
                </WindowStackItem>
            )}
        </ErrorOverlay>
    );
};

type OwnProps = {
    photoId: string;
};

type Props = OwnProps & {
    removePhoto: () => void;
};

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    removePhoto: () => dispatch(photoActions.remove(ownProps.photoId))
});

export const PhotoPrintMobileErrorOverlay = connect(
    null,
    mapDispatchToProps
)(_PhotoPrintMobileErrorOverlay);